export const uploadPaperAssessmentMessages = {
  warning:
    'Are you sure you want to leave this page? You have unsaved changes. If you leave the page, these changes will be lost.',
};
